import { css } from '@fable/theme'
import { ReadingGoalCard } from './ReadingGoalCard'
import { ReadingGoalSuggestion } from './ReadingGoalSuggestion'
import { useReadingGoals } from '../../lib/ctx/reading_goals'
import { useStats } from '../../lib/ctx/stats'
import { ReadingGoalsCardEmpty } from './ReadingGoalsCardEmpty'
import { ReadingGoalsCardLocked } from './ReadingGoalsCardLocked'
import { useState } from 'react'
import { useReadingGoalPermission, useStatsPermission } from '../../lib/hooks'

export const ReadingGoalsTabContent = () => {
  const [isSelfView, yearStatus] = useStats((s) => [s.isSelfView, s.yearStatus])
  const [goals, period, suggestions, closeSuggestion, closedSuggestions] =
    useReadingGoals((s) => [
      s.goals,
      s.period,
      s.suggestions,
      s.closeSuggestion,
      s.closedSuggestions,
    ])
  const suggestion = suggestions.find((s) => s.period_type === period)
  const goalCount = goals.length
  const { isLocked } = useReadingGoalPermission()
  const { isAndroid } = useStatsPermission()
  const [currentAnimatingIndex, setCurrentAnimatingIndex] = useState(0)
  const suggestionFallback =
    isSelfView && !isAndroid && yearStatus === 'current'
  const showAnnualSuggestion = period === 'year' && suggestionFallback

  if (isLocked) {
    if (isSelfView && !isAndroid) {
      if (!!suggestion && !closedSuggestions.includes(period)) {
        return (
          <ReadingGoalSuggestion
            suggestion={suggestion}
            onClose={() => closeSuggestion(period, suggestion.goal_type)}
            forceUpsell
            closable
          />
        )
      }
      return <ReadingGoalsCardLocked />
    }
    return <ReadingGoalsCardEmpty />
  }

  if (goalCount === 0) {
    if (showAnnualSuggestion) {
      return (
        <ReadingGoalSuggestion
          suggestion={{
            goal_type: 'books_finished',
            period_type: 'year',
            number_goal: 15,
          }}
          unlocked
        />
      )
    }
    if (
      suggestionFallback &&
      !!suggestion &&
      !closedSuggestions.includes(period)
    ) {
      return (
        <ReadingGoalSuggestion
          suggestion={suggestion}
          onClose={() => closeSuggestion(period, suggestion.goal_type)}
          closable
          unlocked
        />
      )
    }

    return <ReadingGoalsCardEmpty />
  }

  const hasSuggestion =
    goalCount < 2 &&
    !!suggestion &&
    isSelfView &&
    !isAndroid &&
    yearStatus === 'current' &&
    !closedSuggestions.includes(period)

  const getSuggestion = () => {
    if (!hasSuggestion) return null

    return (
      <ReadingGoalSuggestion
        suggestion={suggestion}
        slim={goalCount === 1}
        onClose={() => closeSuggestion(period, suggestion.goal_type)}
        closable
      />
    )
  }

  return (
    <div
      className={css`
        width: 100%;
        display: grid;
        grid-template-columns: ${goalCount === 1 && !hasSuggestion
          ? 'repeat(1, 1fr)'
          : 'repeat(2, 1fr)'};
        grid-auto-rows: 242px;
        gap: 8px;
      `}
    >
      {goals.map((goal, num) => (
        <ReadingGoalCard
          key={goal.id}
          goal={goal}
          stretched={goalCount === 1 && !hasSuggestion}
          delay={num % 2 === 0 ? 0.3 : 0.8}
          startPetalAnim={num === currentAnimatingIndex}
          onPetalsFilled={() => {
            setCurrentAnimatingIndex((prev: any) => prev + 1)
          }}
        />
      ))}
      {getSuggestion()}
    </div>
  )
}
